import React, { useState,useEffect } from 'react'
import { Card, Col, Container, Row, Button, Input} from 'reactstrap'
import MyTasksDropdown from '../../../../../../../designUtils/OpsDashboard/MyTasks/MyTasksDropdown.svg';
import NewTaskIcon from '../../../../../../../designUtils/OpsDashboard/MyTasks/NewTaskIcon.svg';
import MyTasksUpIcon from '../../../../../../../designUtils/OpsDashboard/MyTasks/MyTasksUpIcon.svg';
import MyTicketsUpIcon from '../../../../../../../designUtils/OpsDashboard/MyTasks/MyTicketsUpIcon.svg';
import MyTicketsDropdown from '../../../../../../../designUtils/OpsDashboard/MyTasks/MyTicketsDropdown.svg';
import { connect } from 'react-redux';
import NotiDropdownUp from '../../../../../../../designUtils/OpsDashboard/MyTasks/NotiDropdownUp.svg';
import NotiDropdown from '../../../../../../../designUtils/OpsDashboard/MyTasks/NotiDropdown.svg';
import CustomModal from "../../../../../../Components/Modals/CustomModal";
import PMGetAllStatisticsService from '../../../../../../../Service/OPSServices/ProactiveMonitoringServices/PMDashboardServices/PMGetAllStatisticsService';
import PMGetAllTasksServices from '../../../../../../../Service/OPSServices/ProactiveMonitoringServices/PMDashboardServices/PMGetAllTasksServices';
import GetUserProfileDataService from '../../../../../../../Service/DashboardServices/UserProfileServices/ProfileDataServices/GetUserProfileDataService';
import LoadingOverlay from 'react-loading-overlay';
import Loader from 'react-loaders';
import PMNotificationsMainFile from './PMNotifications/PMNotificationsMainFile';
import ProactiveTicketMainPage from '../ProactiveTicketModule/ProactiveTicketMainPage';
import PMPieChart from './PMTasks/PMPieChart';
import PMSWTeamTask from './PMTasks/PMSWTeamTask';
import PMCreateNewTask from './PMTasks/PMSubComponentsSwTeamTask/PMCreateNewTask';
import ProactivePartnerTicketListMainPage from '../ProactivePartnerTicketList/ProactivePartnerTicketListMainPage';
import Group from "./../../../../../../../assets/img/StoreOverview_Img/Group.png";

function PMDashBoardMainPage(props) {
  const [tabs, setTabs] = useState(3)
  const [myTaskIcons,setMyTaskIcons]= useState(true)
  const [ticketIcons,setTicketIcons]= useState(false)
  const [createNewTaskPopup,setCreateNewTaskPopup]= useState(false)
  const [taskList, setTaskList] = useState([])
  const [teamMemberList, setTeamMemberList] = useState('')
  const [allStats, setallStats] = useState()
  const [cardTitle, setCardTitle] = useState();
  const[notificationIcons,setNotificationIcons]= useState(false)
  const [agencyMemberList, setAgencyMemberList] = useState('')
  const [LoggedUserRole,setloggedUserRole] = useState()
  const [notificationsDetails,setNotificationsDetails]=useState({
    tabs: props.globalPermissions &&props.globalPermissions.Dashboard_Tasks?3 :4,
    details:'',
    action:'',
    searchparams:''
  })


  const [loggedUserId , setloggedUserId] = useState()
  const [taskCount , setTaskCount] = useState(0)
  const [worflowCount,setworflowCount]= useState(0)
  const [ticketCount,setticketCount]= useState(0)
  const [taskStatus, setTaskStatus] = useState()
  const [loading,setloading]= useState(false)

  const [userData, setUserData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    companyName: "",
  });
  const [statusNames, setstatusName] = useState([])
  const [statusColor, setstatusColor] = useState([])
  const [statusCount, setstatusCount] = useState([])
  const [notiCount, setNotiCount] = useState('0');
  const [refreshTrigger, setRefreshTrigger] = useState(false);
  const [selectedStore, setSelectedStore] = useState(""); 
  const [store, setStore] = useState(0);

  useEffect(() => {
    const fetchData = () => {
    // setloading(true)
    let data={intId:store?store.integerID:0}
    PMGetAllStatisticsService(props.token,data).then((res) => {
      if (res) {
        setNotiCount(res.notiCount);
        setallStats(res)
        res.taskStatistics &&
        res.taskStatistics.length > 0 &&
        setTaskCount(res.taskStatistics[0].count);
        res.ticketStatistics &&
        res.ticketStatistics.length > 0 &&
        setticketCount(res.ticketStatistics[0].count);
        let currentStats = [];
        if (notificationsDetails.tabs === 2) {
          currentStats = res.ticketStatistics || [];
        }
        else {
          currentStats = res.taskStatistics || [];
        }
        const filteredStats = currentStats.filter(
          (item) => item.status !== 'Open'
        );
        setstatusName(filteredStats.map(item => item.status));
        setstatusColor(filteredStats.map(item => item.color));
        setstatusCount(filteredStats.map(item => item.count));
      }
    })
    {props.globalPermissions &&props.globalPermissions.Dashboard_Tasks &&
    PMGetAllTasksServices(props.token,data).then((responce) => {
      if (responce) {
        setloggedUserId(responce.loggedUserId)
        setTaskList(responce.tasklist)
        setloggedUserRole(responce.loggedUserRole)
        setAgencyMemberList(responce.agencyMember)
        setTeamMemberList(responce.teamMembers)
        setTaskStatus(responce.statusList)
        setloading(false)
        // setTaskStatus(responce.statusList)
        // const statusName = responce.statusList.map(item => item.status);
        // setstatusName(statusName)
        // const tasks = responce.tasklist.filter((task) => task.status != 'Completed' && task.assignedTo == responce.loggedUserId);
        // setTaskCount(tasks.length)
      }
    })}
    GetUserProfileDataService(props.token).then((response) => {
      if (response) {
        setUserData({
          firstName: response.firstName,
          lastName: response.lastName,
          email: response.email,
          phone: response.phone,
          companyName: response.companyName,
        })
      }
    })

}

handleTimeDate()
fetchData(); 
  // const intervalId = setInterval(() => {
  //   handleTimeDate();
  //   fetchData();
  // }, 180000); 
  // return () => clearInterval(intervalId);
}, [store,refreshTrigger]); 

const handleStoreChange = (event) => {
  const selectedValue = event.target.value;
  setSelectedStore(selectedValue);

  if (selectedValue === "") {
    setStore({});
  } else {
    const selectedStoreObj = props.adProfiles.find((profile) => profile.integerID.toString() === selectedValue);
    setStore(selectedStoreObj || {});
  }
};

  const handleChangeTabs = (value) => {
    if (value === 2) {
      setCardTitle("My Tickets");
      allStats &&
      allStats.ticketStatistics &&
      allStats.ticketStatistics.filter &&
      setstatusName(
        allStats.ticketStatistics
          .filter((item) => item.status !== 'Open')
          .map((item) => item.status)
      );

    allStats &&
      allStats.ticketStatistics &&
      allStats.ticketStatistics.filter &&
      setstatusColor(
        allStats.ticketStatistics
          .filter((item) => item.status !== 'Open')
          .map((item) => item.color)
      );

    allStats &&
      allStats.ticketStatistics &&
      allStats.ticketStatistics.filter &&
      setstatusCount(
        allStats.ticketStatistics
          .filter((item) => item.status !== 'Open')
          .map((item) => item.count)
      );
      setTicketIcons(!ticketIcons)
      setMyTaskIcons(false)
      setNotificationIcons(false)

    }
    if (value === 3) {
      setCardTitle("My Tasks");
      setstatusName(allStats &&allStats.taskStatistics.filter((item) => item.status !== 'Open').map((item) => item.status))
      setstatusColor(allStats &&allStats.taskStatistics.filter((item) => item.status !== 'Open').map((item) => item.color))
      setstatusCount(allStats &&allStats.taskStatistics.filter((item) => item.status !== 'Open').map((item) => item.count))
      setMyTaskIcons(!myTaskIcons)
      setTicketIcons(false)
      setNotificationIcons(false)
    }
    if (value === 4) {
      setCardTitle("My Notification");
      // setstatusName(allStats &&allStats.taskStatistics.filter((item) => item.status !== 'Open').map((item) => item.status))
      // setstatusColor(allStats &&allStats.taskStatistics.filter((item) => item.status !== 'Open').map((item) => item.color))
      // setstatusCount(allStats &&allStats.taskStatistics.filter((item) => item.status !== 'Open').map((item) => item.count))
      setNotificationIcons(!notificationIcons)
      setTicketIcons(false)
      setMyTaskIcons(false)


    }
    // setMyTaskIcons(value, !myTaskIcons)
    // setShowTabsUi(!showTabsUi)
    // setTabs(value)
    setNotificationsDetails({
      tabs: value,
      details:'',
      action:false,
      searchparams:''
    })
  }
  const handleCreateTaskPopup = () => {

    setCreateNewTaskPopup(true)
  }
  const handleCloseCreateTaskPopup = (task) => {
    setTaskCount(taskCount+1)
    setCreateNewTaskPopup(false)
    setTaskList(task)
    setRefreshTrigger(!refreshTrigger);
  }
  const [currentTime, setCurrentTime] = useState(new Date());
  const handleTimeDate = () => {
    setCurrentTime(new Date());

  }

  const formattedDate = currentTime.toLocaleDateString("en-US", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  const formattedTime = currentTime.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });

  function handleClickViewAnalytic() {
    alert("Development for this functionality is in progress.");
  }

  return (
    <Col className='mt-5 pt-4'>
      <Row>
        <Col md={9}>
          <Row>
            <Col md={12}>
              <h5>
                <b>Hello, {userData.firstName}</b>
              </h5>
              <h6> <b>{`${formattedDate}, ${formattedTime}`}</b></h6>
              <div className="d-flex align-items-center mt-3 mb-3">
                <div>
                  <div className="d-flex align-items-center mb-2 ml-1">
                    <p className="text-center mb-0 mr-2">
                      <img
                        src={store.logo ? store.logo : Group}
                        width={store.logo ? "" : 30}
                        alt="Store Logo"
                        style={{ opacity: selectedStore ? 1 : 0.3 }} 
                      />
                    </p>
                    <h6 className="mb-0 text-truncate">
                      <b>{selectedStore ? store.name : "No Store"}</b>
                    </h6>
                  </div>

                  <div className="px-1">
                    <select
                      id="StoreList"
                      name="StoreList"
                      onChange={handleStoreChange}
                      value={selectedStore}
                      className="form-control form-control-sm w-100"
                    >
                      <option value="">--Select Store--</option> 
                      {props.adProfiles && props.adProfiles.length > 0
                        ? props.adProfiles.map((s) => (
                          <option key={s.integerID} value={s.integerID}>
                            {s.name} ({s.location})
                          </option>
                        ))
                        : null}
                    </select>
                  </div>
                </div>
              </div>
              <div className='d-flex mt-4 mb-3' >
                {/* <div className='d-flex justify-content-center message-color 'onClick={handleClickViewAnalytic}>
                  <h6 className='font-color-heading  mr-2 mt-2' ><b>Messages</b> </h6>
                </div> */}
              { props.globalPermissions && props.globalPermissions.Dashboard_NewTask ? 

              <div className='new-task-color' onClick={handleCreateTaskPopup}>
                <h6 className='font-color-heading  mt-2' ><b>New Task </b> <img className='ml-3 mb-1'  src={NewTaskIcon} /></h6>
              </div>:''}

              </div>
            </Col>
            { props.globalPermissions && props.globalPermissions.Dashboard_Tasks ? 
            <Col md={3}>
              <Card
                onClick={() => { handleChangeTabs(3) }}
                className={`p-4 card-of-problemarea swteam-tasks mt-3`}>
                <h6
                  style={{ color: '#243837' }}
                >
                  <b>Tasks</b></h6>
                <div className="d-flex justify-content-between">
                  <h6 style={{ color: '#243837' }}><b>{taskCount}</b></h6>

                  <img
                    src={myTaskIcons ? MyTasksUpIcon :  MyTasksDropdown} />
                </div>
              </Card>
            </Col>:''}
            { props.globalPermissions && props.globalPermissions.Dashboard_Notifications ? 
            <Col md={3}>
              <Card
                onClick={() => { handleChangeTabs(4) }}
               className={`p-4 card-of-problemarea notification-tasks mt-3`}>
                <h6
                style={{color: '#243837' }}>
                  <b>Notifications</b>
                </h6>
                <div className="d-flex justify-content-between">
                <h6 style={{ color: '#243837' }}><b>{notiCount}</b></h6>
                <img src={notificationIcons ? NotiDropdownUp:  NotiDropdown } />
                </div>
              </Card>
            </Col>:""}
           
            { props.globalPermissions && props.globalPermissions.Dashboard_Tickets ? 
            <Col md={3}>
              <Card
                onClick={() => { handleChangeTabs(2) }}
                className={`p-4 card-of-problemarea ticket-tasks mt-3`} >
                <h6
                  style={{ color: '#243837' }}
                >
                  <b>Tickets</b></h6>
                <div className="d-flex justify-content-between">
                  <h6 style={{ color: '#243837' }}><b>{ticketCount}</b></h6>

                  <img src={ticketIcons ?  MyTicketsUpIcon:  MyTicketsDropdown} alt="Dropdown Icon" />
                </div>
              </Card>
              </Col>:''}
          </Row>

        </Col>
        {notificationsDetails.tabs!==4 &&
        <Col md={3}>
        <Card className='card-of-problemarea p-2' style={{ height: '275px' }}>
          <div className='custom-task-overview'>
            <h5 className='text-center'><b>{cardTitle?cardTitle:"My Tasks"}</b></h5></div>
          {/* <h6 className='text-center'><b>Nov 2024</b></h6>    */}
          <PMPieChart Status={statusNames} count={statusCount} color={statusColor} />
        </Card>
      </Col>


        }
        
        <Col md={12}>
        <LoadingOverlay
          active={loading}
          styles={{
            overlay: (base) => ({
              ...base,
              background: '#f1f4f6',
              opacity: 1,
            }),
            content: (base) => ({
              ...base,
              color: '#000',
            }),
          }}
          spinner={<Loader active type="ball-pulse" />}
          text='Loading your Tasks...'
      >
          { 
              notificationsDetails.tabs === 2 ? //TicketList component
                            (LoggedUserRole==2 ||LoggedUserRole==22 || LoggedUserRole==6?
                              <ProactivePartnerTicketListMainPage  //2- Partner , 6-Agency Client, 22- store manager
                              notificationsDetails={notificationsDetails}
                            setNotificationsDetails={setNotificationsDetails}
                            store={store} setStore={setStore}
                              isMyworksScreen={true}
                              />:   
                            (<ProactiveTicketMainPage isMyworksScreen={true} 
                              dashDtore={store} setDashStore={setStore}
                            notificationsDetails={notificationsDetails}
                            setNotificationsDetails={setNotificationsDetails}/> ))
              
              : notificationsDetails.tabs === 4 ? (
                // Notifications component
                <PMNotificationsMainFile
                  isMyworksScreen={true}
                  searchparams={''}
                  store={store} setStore={setStore}
                  notificationsDetails={notificationsDetails}
                  setNotificationsDetails={setNotificationsDetails}
                />
              ) : notificationsDetails.tabs === 3 ? (
                // Task component
                <PMSWTeamTask
                  LoggedUserRole={LoggedUserRole}
                  store={store} setStore={setStore}
                  setAgencyMemberList={setAgencyMemberList}
                  agencyMemberList={agencyMemberList}
                  setloading={setloading}
                  notificationsDetails={notificationsDetails}
                  setNotificationsDetails={setNotificationsDetails}
                  setstatusCount={setstatusCount}
                  setTaskStatus={setTaskStatus}
                  taskStatus={taskStatus}
                  loggedUserId={loggedUserId}
                  setTaskList={setTaskList}
                  taskList={taskList}
                  userData={userData}
                  teamMemberList={teamMemberList}
                  setTeamMemberList={setTeamMemberList}
                />
              ) : (
                ''
              )
            }
          </LoadingOverlay>
        </Col>
      </Row>
      <CustomModal
        header={"Create New Task"}
        isOpen={createNewTaskPopup}
        toggle={() => setCreateNewTaskPopup(!createNewTaskPopup)}
        size={"xl"}
        className='my-task-custom-module'
      >
          <Card className='card-of-problemarea'>
          <PMCreateNewTask
           setAgencyMemberList={setAgencyMemberList}
           agencyMemberList={agencyMemberList}
           store={store} setStore={setStore}
           loggedUserId={loggedUserId}
            teamMemberList={teamMemberList}
            taskList={taskList}
            setTaskCount={setTaskCount}
            taskCount={taskCount}
            setstatusCount={setstatusCount}
            handleCloseCreateTaskPopup={handleCloseCreateTaskPopup}
          />
        </Card>
      </CustomModal>
    </Col>
  )
}

const mapStateToProps = state => {
  return {
      token: state.loggedUser.token,
      accessLevel: state.loggedUser.accessLevel,
      status: state.loggedUser.status,
      globalPermissions: state.loggedUser.globalPermissions,
      adProfiles: state.accountOverview.landing.adProfiles,
  }
}

export default connect(mapStateToProps)(PMDashBoardMainPage);
